import React from 'react';
import { DispatchProp } from 'react-redux';
import { useSetResolved } from 'src/core/engine/router';
import { CmsDeliveryPage } from 'src/components/CmsPage/CmsDeliveryPage';
import { DefaultMeta } from 'src/components/AppShell/Head';

import '../../scss/_root-component.scss';

import meta from './CmsDelivery.json';

type Props = {
    id: number;
} & DispatchProp<any>;

export const CmsDelivery: React.FC<Props> = () => {
    useSetResolved();
    return (
        <>
            <DefaultMeta data={meta.helmet} />
            <CmsDeliveryPage />
        </>
    );
};

export default CmsDelivery;
